import {createSelector} from "reselect";
import {getConfigState} from "../root-selectors";
import {ConfigState} from "./types";

export const getIsOnboarding = createSelector(
    [getConfigState],
    (state: ConfigState): boolean => state.isOnboarding,
)
